import { defineNuxtPlugin, useRequestHeaders } from '#app'
import { isWebViewFarmi } from '@b2ag/farmi-app-appro-tools'

export default defineNuxtPlugin(() => {
  const userAgent = import.meta.server ? useRequestHeaders()['user-agent'] : navigator.userAgent
  const isFarmiAppUserAgent = isWebViewFarmi(userAgent)

  return {
    provide: {
      isFarmiAppUserAgent: () => isFarmiAppUserAgent,
    },
  }
})
